
function ConsoleData (ajax, opts) {
  this.ajax = ajax;

  this.download = function (filename, text) {
    return this.ajax.download(filename, text);
  }

  this._pre = function (BASE_URL, conf) {

    if (opts.filename) {
      BASE_URL = BASE_URL + "/" + conf.data.filename
      delete conf.data.filename;
    }

    if (opts.mapping && opts.mapping.when.some((r) => r.test(BASE_URL))) {

      // do mapping
      opts.mapping.rules.forEach((rule, i) => {
        var strRule = "\/[a-zA-Z_0-9]+" + rule.endsWith.replace(".", "\.") + "$"
        var reg = new RegExp(strRule)
        //console.log('testing rule: ', BASE_URL, strRule, rule.replaceWith, reg.test(BASE_URL))
        if (reg.test(BASE_URL)) {
            BASE_URL = BASE_URL.replace(reg, "/" + rule.replaceWith)
        }
      })
    }

//    console.log('getting file from: ', BASE_URL, opts.mapping.when.some((r) => r.test(BASE_URL)), this.ajax, conf)

    return [BASE_URL, conf]
  }

  this.window_open = function (BASE_URL, conf) {
    return this.ajax.window_open(...this._pre(BASE_URL, conf));
  }

  this.promise_jsonp = function (BASE_URL, conf) {
    console.log('jsonp: ', BASE_URL, conf)
    return this.ajax.promise_json(...this._pre(BASE_URL, conf));
  }
  this.promise_text = function (BASE_URL, conf) {
    console.log('text: ', BASE_URL, conf)
    return this.ajax.promise_text(...this._pre(BASE_URL, conf));
  }
}

export {
  ConsoleData
}



// WEBPACK FOOTER //
// ./app/ConsoleData.jsx